<template>
  <div>
    <div class="information_box">
      <div class="information_title">
        <span class="name">{{ NameAll.name }}</span>
        <el-checkbox
          v-model="NameAll.checkAll"
         
          @change="handleCheckAllChange(NameAll, $event)"
        ></el-checkbox>
      </div>
      <div
        v-for="(item2, index) in NameAll.child"
        :key="item2.id"
        class="information_item"
      >
        <el-checkbox
          v-model="item2.checkAllTwo"
          @change="handleCheckTwoAllChange(index, $event)"
        ></el-checkbox>
        <span class="nameTwo">{{ item2.name }}</span>
        <div v-for="city in item2.child" :key="city.id">
          <el-checkbox
            :key="city.id"
            v-model="city.checkAllTwo"
            @change="handleCheckedCitiesChange(city.id, index, $event)"
            >
            <span class="nameTwo">{{ city.name }}</span></el-checkbox
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    NameAll: {
      type: Object,
    },
    checkActCities: {
      type: Array,
    },
  },
  data() {
    return {
      checkAll: false, //是否全选
      checkAllTwo: false, //判断是否二级全选
      checkedCities: [], //三级选中的数据
      PerIDList: [], //选中的权限ID数据
      PerItemList: [], //选中的权限ID数据
    };
  },
  mounted() {
    this.NameAll.checkAll = false;
    if (this.NameAll.child) {
      this.NameAll.child.forEach((item) => {
        item.checkAllTwo = false;
        if (item.child) {
          item.child.forEach((item2) => {
            item2.checkAllTwo = false;
          });
        }
      });
    }
    if (this.checkActCities && this.checkActCities.length > 0) {
      this.checkActCities.forEach((item) => {
        if (this.NameAll.id) {
          if (item == this.NameAll.id) {
            this.NameAll.checkAll= true;
          }
          if (this.NameAll.child && this.NameAll.child.length > 0) {
            this.NameAll.child.forEach((element) => {
                if (item ==element.id) {
                    element.checkAllTwo= true;
                }
              if (element.child && element.child.length > 0) {
                element.child.forEach((index) => {
                  if (item ==index.id) {
                    index.checkAllTwo= true;
                }
                });
              }
            });
          }
        }
      });
    }
        this.$forceUpdate();
  },
  methods: {
    getData() {
      let top2lemgth = this.NameAll.child;
      if (this.NameAll.checkAll == true) {
        this.PerIDList.push(this.NameAll.id);
      }
      if (top2lemgth) {
        for (var i = 0; i < top2lemgth.length; i++) {
          if (top2lemgth[i].checkAllTwo == true) {
            this.PerIDList.push(top2lemgth[i].id);
          }
          if (top2lemgth[i].child) {
            for (let index = 0; index < top2lemgth[i].child.length; index++) {
              if (top2lemgth[i].child[index].checkAllTwo == true) {
                this.PerIDList.push(top2lemgth[i].child[index].id);
              }
            }
          }
        }
      }
    },
    handleCheckAllChange(val, e) {
      //操作权限的全选事件
      let top2lemgth = this.NameAll.child;
      this.NameAll.checkAll = e;
      if (top2lemgth) {
        for (var i = 0; i < top2lemgth.length; i++) {
          top2lemgth[i].checkAllTwo = e;
          if (top2lemgth[i].child) {
            for (let index = 0; index < top2lemgth[i].child.length; index++) {
              top2lemgth[i].child[index].checkAllTwo = e;
            }
          }
        }
      }
      this.$forceUpdate();
    },
    handleCheckTwoAllChange(index, e) {
      //操作权限二级的全选事件
      let top2 = this.NameAll.child[index];
      top2.checkAllTwo = e;
      if (top2.child) {
        for (var i = 0; i < top2.child.length; i++) {
          top2.child[i].checkAllTwo = e;
        }
      }
      this.$forceUpdate();
    },
    handleCheckedCitiesChange(id, index, e) {
      //操作权限的三级选择事件
      let top2 = this.NameAll.child[index].child;
      var tickCount = 0,
        unTickCount = 0,
        top2lemgth = top2.length;
      for (var i = 0; i < top2lemgth; i++) {
        if (id == top2[i].id) {
          top2[i].checkAllTwo = e;
        }
        if (top2[i].checkAllTwo == true) {
          tickCount++;
          // this.checkedCities.push(element)
        }
        if (top2[i].checkAllTwo == false) {
          unTickCount++;
        }
      }
      if (tickCount == top2lemgth) {
        //三级级全勾选
        this.$forceUpdate();
        this.NameAll.child[index].checkAllTwo = true;
      } else if (unTickCount == top2lemgth) {
        //三级级全不勾选
        this.$forceUpdate();
        this.NameAll.child[index].checkAllTwo = false;
      } else {
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.information_box {
  // padding:0 15px;
  background-color: #fff;
  .information_title {
    position: relative;
    color: #333333;
    font-size: 16px;
    font-weight: bold;
    line-height: 56px;
    padding-left: 15px;
    background-color: #fafafa;
    .name {
      margin-right: 12px;
    }
  }
  .information_title::after {
    content: "";
    position: absolute;
    top: 20px;
    left: 0px;
    background-color: #0084ff;
    width: 3px;
    height: 16px;
  }
  .information_item {
    display: flex;
    align-items: center;
    padding: 22px 0;
    border-bottom: 1px solid #f1f1f1;
    .nameTwo {
      margin-right: 32px;
      margin-left:10px;
    }
  }
}
</style>